export default "__VITE_ASSET__fJ$$ApkL0T8W1xl5FvH2Eg__"